var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description-item"},[_c('div',{staticClass:"label",style:(_vm.labelStyle)},[_vm._v("\n    "+_vm._s(_vm.label)+"：\n  ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n    "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145f0a52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Description/descriptionItem.vue
// module id = null
// module chunks = 